import certificates from './routes'

export default [...certificates] as const
